import React from "react";
// import Select from "react-select";
// import { Select as TagSelect } from "antd";
// import { DatePicker } from "antd";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
// import { Edit } from "feather-icons-react/build/IconComponents";

import InvoiceBillTo from "./InvoiceBillTo";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { Table } from "antd";

const ViewInvoice = () => {
  //   const [startDate, setStartDate] = useState(new Date("2025-03-26"));
  //   const [endDate, setEndDate] = useState(new Date("2025-04-10"));
  //   const [items, setItems] = useState([]);
  //   const [discount, setDiscount] = useState(0);
  //   const [adjustment, setAdjustment] = useState(0);
  //   const [quantityOption, setQuantityOption] = useState("Qty");
  const TermsConditons = {
    details: `1) Warranty : 12 months from date of Installation. The materials are not covered if its failed due to power fluctuation /
  accidents / physical damages
  2) Incase of any issues with software integration, Perennial Code will provide you an alternate of punches from device.
  3) Devices once installed or used will not be taken back (No Refund)`,
  };

  // Calculate IGST (18%)
  //   const calculateIGST = (subtotal) => {
  //     return (subtotal * 18) / 100;
  //   };

  // Calculate Discount
  //   const calculateDiscount = (subtotal) => {
  //     return (subtotal * discount) / 100;
  //   };

  // Calculate Total
  //   const calculateTotal = () => {
  //     const subtotal = calculateSubtotal();
  //     const discountAmount = calculateDiscount(subtotal);
  //     const igst = calculateIGST(subtotal);
  //     return subtotal - discountAmount + igst + adjustment;
  //   };

  //   const statusOptions = [
  //     { value: "draft", label: "Draft" },
  //     { value: "sent", label: "sent" },
  //     { value: "open", label: "open" },
  //     { value: "Revised", label: "Revised" },
  //     { value: "Declined", label: "Declined" },
  //     { value: "Accepted", label: "Accepted" },
  //   ];
  //   const AssignedOptions = [
  //     { value: "Venkatesh D", label: "Venkatesh D" },
  //     { value: "Venkatesh Nama", label: "Venkatesh Nama" },
  //     { value: "SreePavani Chivukula", label: "SreePavani Chivukula" },
  //     { value: "Siva", label: "Siva" },
  //     { value: "Sharma", label: "Sharma" },
  //     { value: "Pavan Sai", label: "Pavan Sai" },
  //   ];

  //   const currencyOptions = [
  //     { value: "INR", label: "INR Rs." },
  //     { value: "USD", label: "USD $" },
  //     { value: "EUR", label: "EUR €" },
  //     { value: "KSH", label: "KSH " },
  //   ];

  //   const discountOptions = [
  //     { value: "none", label: "No discount" },
  //     { value: "Before Tax", label: "Before Tax" },
  //     { value: "After Tax", label: "After Tax" },
  //   ];

  const invoicedata = [
    {
      id: 1,
      item: "AMC",
      description: "Application Annual Subscription Charges",
      qty: 2,
      hours: 2,
      rate: 6000,
      tax: "9.00%",
    },
  ];

  const transactionData = [
    {
      key: "1",
      paymentNo: "1781",
      paymentMode: "Bank",
      date: "16/09/2025",
      amount: 14160,
    },
  ];

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Item",
      dataIndex: "item",
      render: (_, record) => (
        <>
          <div className="fw-semibold">{record.item}</div>
          <small className="text-muted">{record.description}</small>
        </>
      ),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      align: "center",
      render: (qty) => `${qty} Terminals`,
    },
    {
      title: "Rate",
      dataIndex: "rate",
      align: "right",
      render: (rate) => `₹ ${Number(rate).toLocaleString("en-IN")}`,
    },
    {
      title: "Tax",
      dataIndex: "tax",
      align: "center",
      render: (tax) => (
        <>
          <div>SGST {tax}</div>
          <div>CGST {tax}</div>
        </>
      ),
    },
    {
      title: "Amount",
      align: "right",
      render: (_, record) => {
        const total = Number(record.qty || 0) * Number(record.rate || 0);
        return (
          <strong>
            ₹{" "}
            {total.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
          </strong>
        );
      },
    },
  ];

  const transactionColumns = [
    {
      title: "Payment #",
      dataIndex: "paymentNo",
      key: "paymentNo",
      render: (text) => (
        <span className="fw-semibold text-primary">{text}</span>
      ),
    },
    {
      title: "Payment Mode",
      dataIndex: "paymentMode",
      key: "paymentMode",
      render: (mode) => (
        <span>
          <i className="fa-solid fa-building-columns text-success me-2"></i>
          {mode}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => (
        <span>
          <i className="fa-regular fa-calendar-days text-danger me-2"></i>
          {date}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (amount) => (
        <span className="fw-bold text-success">
          Rs.
          {Number(amount).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
          })}
        </span>
      ),
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        <div className="content ">
          <nav aria-label="breadcrumb">
            <div className="d-flex justify-content-between align-items-center ms-3">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/crm/Dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item mb-0" aria-current="page">
                  View Inovice
                </h4>
              </ol>
              <div
                className="d-flex align-items-center"
                style={{ marginBottom: "-1rem" }}
              >
                <Link to="/crm/invoices" className="btn btn-secondary mb-2">
                  <i className="ti ti-arrow-left me-1"></i>Back
                </Link>
              </div>
            </div>
          </nav>
          <p className="ms-4">Manage your Invoices here</p>

          <div className="mt-4">
            <div className="card card-body">
            
                <div className="row">
                  {/* Company & Bill Details */}
                  <div className="col-lg-8">
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        {/* Invoice Number */}
                        <div className="d-flex align-items-center mb-4">
                          <i className="fa-solid fa-file-invoice text-primary fs-3 me-3"></i>

                          <div>
                            <h4 className="mb-0 fw-bold">INV-2025/1590</h4>
                            <small className="text-muted">Invoice Number</small>
                          </div>
                        </div>

                        <hr />

                        <div className="row">
                          {/* Company Details */}
                          <div className="col-md-6 border-end">
                            <h5 className="fw-bold text-primary mb-3">
                              <i className="fa-solid fa-building me-2"></i>
                              Company Details
                            </h5>

                            <h6 className="fw-bold">
                              Perennial Code IT Consultants Pvt. Ltd.
                            </h6>

                            <p className="mb-1">
                              <i className="fa-solid fa-location-dot text-danger me-2"></i>
                              Vidya Nagar
                            </p>

                            <p className="mb-1">Hyderabad, Telangana</p>

                            <p className="mb-1">INDIA - 500044</p>

                            <p className="mb-1">
                              <i className="fa-solid fa-receipt text-success me-2"></i>
                              GSTIN :<strong> 36AAHCP8044R1ZM</strong>
                            </p>

                            <p className="mb-0">
                              <i className="fa-solid fa-phone text-primary me-2"></i>
                              +91 4048513363
                              <br />
                              +91 8297230010
                            </p>
                          </div>

                          {/* Bill To */}
                          <div className="col-md-6">
                            <h5 className="fw-bold text-primary mb-3">
                              <i className="fa-solid fa-user me-2"></i>
                              Bill To
                            </h5>

                            <h6 className="fw-bold">BALAJI FRESH</h6>

                            <p className="mb-1">H.NO-4-42-1068/A,</p>

                            <p className="mb-1">ASBESTOS HILLS COLONY,</p>

                            <p className="mb-1">KUKATPALLY,</p>

                            <p className="mb-1">MEDCHAL (MALKAJGIRI)</p>

                            <p className="mb-1">Hyderabad, Telangana</p>

                            <p className="mb-1">INDIA - 571234</p>

                            <p className="mb-0">
                              <i className="fa-solid fa-receipt text-success me-2"></i>
                              GSTIN :<strong> No</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Invoice Details */}
                  <div className="col-lg-4">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-primary text-white">
                        <h5 className="mb-0">Invoice Details</h5>
                      </div>

                      <div className="card-body">
                        <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
                          <span className="text-muted">
                            <i className="fa-regular fa-calendar me-2"></i>
                            Invoice Date
                          </span>

                          <strong>15/09/2025</strong>
                        </div>

                        <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
                          <span className="text-muted">
                            <i className="fa-regular fa-clock me-2"></i>
                            Due Date
                          </span>

                          <strong>25/09/2025</strong>
                        </div>

                        <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
                          <span className="text-muted">
                            <i className="fa-solid fa-credit-card me-2"></i>
                            Payment Mode
                          </span>

                          <strong>UPI</strong>
                        </div>

                        <div className="d-flex justify-content-between border-bottom pb-3">
                          <span className="text-muted">
                            <i className="fa-solid fa-user-tie me-2"></i>
                            Sales Agent
                          </span>

                          <strong>Abdul Shaik</strong>
                        </div>

                        <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
                          <span className="text-muted">
                            <i className="fa-solid fa-money-bill me-2"></i>
                            Currency
                          </span>

                          <strong>INR (₹)</strong>
                        </div>

                        {/* <div className="d-flex justify-content-between">
                          <span className="text-muted">
                            <i className="fa-solid fa-percent me-2"></i>
                            Discount Type
                          </span>

                          <strong>Percentage</strong>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="row">
                  <Table
                    columns={columns}
                    dataSource={invoicedata}
                    rowKey="id"
                    bordered
                    pagination={false}
                  />

                  {/* Subtotal, Discount, IGST, and Total */}
                  <div className="row mt-4">
                    <div className="col-md-7"></div>

                    <div className="col-md-5">
                      <div className="card border-0 shadow-sm">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <span className="text-muted">
                              <i className="fa-solid fa-calculator text-primary me-2"></i>
                              Sub Total
                            </span>
                            <strong>Rs.12,000.00</strong>
                          </div>

                          <hr className="my-2" />

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <span className="text-muted">
                              <i className="fa-solid fa-percent text-success me-2"></i>
                              SGST (9.00%)
                            </span>
                            <strong>Rs.1,080.00</strong>
                          </div>

                          <hr className="my-2" />

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <span className="text-muted">
                              <i className="fa-solid fa-percent text-success me-2"></i>
                              CGST (9.00%)
                            </span>
                            <strong>Rs.1,080.00</strong>
                          </div>

                          <hr className="my-2" />

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <span className="fw-semibold">
                              <i className="fa-solid fa-wallet text-primary me-2"></i>
                              Total
                            </span>
                            <h5 className="mb-0 text-primary">Rs.14,160.00</h5>
                          </div>

                          <hr className="my-2" />

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <span className="text-success">
                              <i className="fa-solid fa-circle-check me-2"></i>
                              Total Paid
                            </span>
                            <strong className="text-success">
                              -Rs.14,160.00
                            </strong>
                          </div>

                          <hr className="my-2" />

                          <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-bold">
                              <i className="fa-solid fa-money-bill-wave text-danger me-2"></i>
                              Amount Due
                            </span>

                            <span className="badge bg-success fs-6 px-3 py-2">
                              Rs.0.00
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <div className="row">
                  {/* Client Note */}
                  <div className="col-12">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-light">
                        <h6 className="mb-0">
                          <i className="fa-solid fa-note-sticky text-primary me-2"></i>
                          Client Note
                        </h6>
                      </div>

                      <div className="card-body">
                        <p className="mb-0 text-muted">
                          Payment Terms : 100% Advance for Hardware
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Terms & Conditions */}
                  <div className="col-12">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-light">
                        <h6 className="mb-0">
                          <i className="fa-solid fa-file-contract text-success me-2"></i>
                          Terms & Conditions
                        </h6>
                      </div>

                      <div className="card-body">
                        <p className="mb-0 text-muted">
                          {TermsConditons.details}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card border-0 shadow-sm ">
                  <div className="card-header bg-light">
                    <h5 className="mb-0">
                      <i className="fa-solid fa-money-check-dollar text-primary me-2"></i>
                      Transactions
                    </h5>
                  </div>

                  <div className="card-body p-0">
                    <Table
                      columns={transactionColumns}
                      dataSource={transactionData}
                      pagination={false}
                      bordered
                    />
                  </div>
                </div>
                
              
            </div>
          </div>
          <InvoiceBillTo />
          <CommonFooter />
        </div>
      </div>
    </>
  );
};

export default ViewInvoice;
